import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: '815b2f75-4ecd-49ee-9870-3175171c3e70',
  ENV: 'blois',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
    authentication: {
      enabled: true,
      appleProviderEnabled: false,
      facebookProviderEnabled: false,
      googleProviderEnabled: false,
    },
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: -1,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
